import { Loader2 } from 'lucide-react';

interface LoadingPhaseProps {
  message?: string;
  color?: 'blue' | 'orange';
}

export function LoadingPhase({
  message = '加载中...',
  color = 'blue'
}: LoadingPhaseProps) {
  const colorClass = color === 'blue' ? 'text-blue-600' : 'text-orange-600';

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <Loader2 className={`w-12 h-12 ${colorClass} animate-spin mb-4`} />
      <p className="text-gray-500">{message}</p>
    </div>
  );
}
